var portfolioBreakdown = {
	table: {
		caption: "Portfolio Breakdown",
		name: {
			assetClass: "Asset class",
			currency: "Currency",
			sector: "Sector"
		}
	},
	chart: {
		counting: {
			assetClass: "Clases de activos",
			currency: "Monedas",
			sector: "Sectores"
		},
		topPositions: {
			assetClass: "Top asset classes",
			currency: "Top currencies",
			sector: "Top sectors"
		}
	},
	assetClasses: {
		bond: "Bono",
		commodity: "Materia prima",
		currency: "Moneda",
		debt: "Deuda",
		etf: "Fondo cotizado",
		fund: "Fondo",
		generic: "Genérico",
		index: "Índice",
		stock: "Acciones",
		interestRate: "Tasa de interés",
		structuredProduct: "Producto estructurado",
		investmentProduct: "Producto de inversión",
		leveragedProduct: "Producto apalancado",
		option: "Opción",
		future: "Futuro"
	}
};
var es = {
	portfolioBreakdown: portfolioBreakdown
};

export { es as default, portfolioBreakdown };
